import { SCRATCH_AND_WIN_LIB } from 'config';

export const urlDeteilsGrattaeVinci = SCRATCH_AND_WIN_LIB;

export const listTransactionState = [
  { optionId: -1, label: 'Tutti' },
  { optionId: 0, label: 'Prenotato' },
  { optionId: 1, label: 'Completato' },
  { optionId: 2, label: 'Annullato' },
];

export const listPeriodListPlayList = [
  { optionId: 7, label: 'Ultimi 7 giorni' },
  { optionId: 30, label: 'Ultimi 30 giorni' },
  { optionId: 90, label: 'Ultimi 90 giorni' },
  { optionId: 180, label: 'Tutti' },
];

export const LabeTransactionState = {
  0: 'Prenotato',
  1: 'Completato',
  2: 'Annullato',
};

export const listPlayListState = [
  { optionId: -1, label: 'Qualunque' },
  { optionId: 1, label: 'Vincente Fascia Alta' },
  { optionId: 3, label: 'Vincente Fascia Bassa' },
  { optionId: 2, label: 'Non vincente' },
  /* { optionId: 0, label: 'In attesa di risultato' },
   */
];

// The initial value of 'select-transaction-state'.
export const defaultSelectTransactionStateOption =
  listTransactionState[0].optionId;

// The initial value of 'select-play-state' for 'listPlayList'.
export const defaultSelectListPlayListStateOption =
  listPlayListState[0].optionId;

// The initial value of 'select-period'.
export const defaultSelectPeriodListPlayListOption =
  listPeriodListPlayList[0].optionId;

export const allLabeTransactionStateIds: {
  [key: string]: any;
} = LabeTransactionState;
